/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import ContactMail from "@mui/icons-material/ContactMail";
import Phone from "@mui/icons-material/Phone";
import Favorite from "@mui/icons-material/Favorite";
// core components
//Use the HeaderTribalism2 element when adding in the top banner!!
//import Header from "components/Header/HeaderTribalism2.js";
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
//import Parallax from "components/Parallax/Parallax.js";
import Parallax from "components/Parallax/Parallax_noscale.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

// sections for this page
import AboutUs from "pages-sections/services/google-ads-services/AboutUs.js";
import Examples from "pages-sections/services/google-ads-services/Examples.js";
import AdsPackage from "pages-sections/services/google-ads-services/AdsPackage.js";
import Guarantee from "pages-sections/services/google-ads-services/Guarantee.js";
import WhyUs from "pages-sections/services/google-ads-services/WhyUs.js";
import OurApproach from "pages-sections/services/google-ads-services/OurApproach.js";

import SectionText from "pages-sections/services/google-ads-services/SectionText.js";

import SectionBlogInfo from "pages-sections/blog-post/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/SectionSimilarStories.js";
import Section4Clients from "pages-sections/home-page/Section4ClientsLandingPage.js";
import Section8Contacts from "pages-sections/home-page/Section8Contacts.js";

import profilePageStyle from "styles/jss/nextjs-material-kit-pro/pages/profilePageStyle.js";
import nsStyle from "styles/jss/nextjs-material-kit-pro.js";
import classNames from "classnames";
import Box from "@mui/material/Box";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Image from "next/image";

import blogPostPageStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostPageStyle.js";
import sectionTextStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionTextStyle.js";

import glossaryStyle from "styles/jss/nextjs-material-kit-pro/pages/glossaryStyle.js";

import bannerStyles from "styles/jss/nextjs-material-kit-pro/components/bannerStyle.js";

import Banner from "components/Banner/Banner.js";
import SimilarPages from "pages-sections/glossary/SimilarPages.js";

import data from "data/linksData3.js"; // Adjust the path accordingly
import LinksList from "components/LinksList/LinksList.js"; // Adjust the path accordingly

const combinedStyles = {
  ...blogPostPageStyle,
  ...sectionTextStyle,
  ...profilePageStyle,
};

const useStyles = makeStyles(glossaryStyle);

const main_section = "web_analytics";
const sub_section = "fundamental_concepts";
const this_page = "Hit";

export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();

  // Extract the description from pageData

  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        //title={pageTitle}
        title="Web Analytics Glossary - Tribalism"
        //image="/img/sections/services/all-services/4-sm.webp"
        image="/img/sections/services/all-services/melbourne-sm.webp"
        url="https://www.tribalism.com.au/services/web-analytics"
        type="article"
        description="We are an Analytics, Web Development and Digital Marketing Agency based in Melbourne. We can get started on big-impact projects for your business immediately! Reach out any time."
        //description={
        //  pageDescription ||
        //  "We are an Analytics, Web Development and Digital Marketing Agency based in Melbourne. We can get started on big-impact projects for your business immediately! Reach out any time."
        //}
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />

      <Parallax
        image="/img/sections/services/all-services/7-sm.webp"
        filter="dark"
      ></Parallax>

      <div className={classes.main} style={{ marginTop: "30px" }}>
        <div
          style={{
            backgroundSize: "100% 100%",
            bbackgroundImage: "none",
            backgroundColor: "white",
            //boxShadow:
            //  "0 4px 20px 0px rgb(0 0 0 / 14%), 0 7px 12px -5px rgb(0 172 193 / 46%)",
          }}
        >
          <div className={classes.container}>
            <div className={classes.section} style={{ padding: "0px" }}></div>
            <br />
            <h2 className={classes.title}>Web Analytics Glossary</h2>

            <LinksList />
            <br />
            <br />
          </div>
        </div>

        <Section8Contacts id="testimonials" />
      </div>
      <Footer
        content={
          <div>
            <div className={classes.left}></div>
          </div>
        }
      />
    </div>
  );
}
